import SkeletonButton from 'antd/es/skeleton/Button';
import { withConfigProvider } from '../config-provider';
export default withConfigProvider(SkeletonButton);
